
export function pushVacancy(vacancyId, ajaxFn, fetchFn, that) {
  let url = 'vacancies/' + vacancyId + '/push'
  ajaxFn(url, null, null, (response) => {
    that.setState({
      errorMsg: ''
    })
    if(response.Errors){
      that.setState({
        errorMsg: response.Errors[0].Messages[0]
      })
      return false;
    }else{
      return fetchFn();
    }
  });
}
